import React from 'react'
import styled from 'styled-components'

const MenuWrapper = styled.nav`
  ${(p) => p.mobileMenuIsHidden && 'display: none;'}
  @media (min-width: ${(p) => p.theme.breakpointLg}) {
    display: block;
    width: 350px;
    flex-shrink: 0;
  }
`

const MenuSection = styled.ul`
  display: flex;
  flex-direction: column;
  :not(:first-child) {
    margin-top: 40px;
  }
  @media (min-width: ${(p) => p.theme.breakpointLg}) {
    width: 255px;
  }
`

const MenuHeading = styled.h2`
  padding: 4px 8px;
  margin-bottom: 16px;
  font-weight: 500;
  font-size: 31px;
  line-height: 148%;
`

const MenuItem = styled.li`
  :not(:last-child) {
    margin-bottom: 8px;
  }
`

const MenuButton = styled.button`
  width: 100%;
  padding: 2px 8px;
  border-radius: 4px;
  text-align: left;
  font-weight: 600;
  font-size: 16px;
  line-height: 175%;
  letter-spacing: 0.25px;
  border: 2px solid transparent;
  outline: none;
  :hover {
    background-color: #f0f1f6;
  }
  :focus-visible {
    border: 2px solid #458fff;
  }
  :active {
    background-color: #ff8de3;
    border: 2px solid transparent;
  }
  :disabled {
    color: #ac9eb9;
    background-color: transparent;
    border: 2px solid transparent;
  }
  ${(p) => p.active && `background-color: ${p.theme.purpleGreyDark};`}
`

const introductionSection = {
  heading: '',
  items: ['Introduction'],
}

const stylesSection = {
  heading: 'Styles',
  items: ['Colour', 'Images', 'Typography', 'Grids and layout', 'Iconography'],
}

const componentsSection = {
  heading: 'Components',
  items: [
    'Buttons',
    'Form elements',
    'Lists',
    'Navigation',
    'Stats',
    'Tables',
    'Content highlight',
    'Dropdown',
    'Inset text',
    'Logo',
    'Notification',
    'Code block',
    'Tags',
    'Toggle',
    'Text area',
    'Accordion',
  ],
}

const patternsSection = {
  heading: 'Patterns',
  items: ['Text and image', 'Text, icon and images', 'Video and text', 'Carousel', 'Confirmation', 'Call to action'],
}

const sections = [introductionSection, stylesSection, componentsSection, patternsSection]

const Menu = ({ currentSection, setCurrentSection, mobileMenuIsHidden, setMobileMenuIsHidden }) => {
  return (
    <MenuWrapper mobileMenuIsHidden={mobileMenuIsHidden}>
      {sections?.map((section, index) => {
        const heading = section?.heading
        const items = section?.items
        return (
          <MenuSection key={index}>
            {heading && <MenuHeading>{heading}</MenuHeading>}
            {items?.map((item, index) => {
              return (
                <MenuItem key={index}>
                  <MenuButton
                    active={currentSection === item}
                    onClick={() => {
                      setCurrentSection(item)
                      setMobileMenuIsHidden(true)
                      window.scrollTo({ top: 0, behavior: 'smooth' })
                    }}
                  >
                    {item}
                  </MenuButton>
                </MenuItem>
              )
            })}
          </MenuSection>
        )
      })}
    </MenuWrapper>
  )
}

export default Menu
